module.exports = __webpack_public_path__ + "static/media/DM.0cfd27dd.png";